var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-button",
    {
      attrs: { type: "text", loading: _vm.loading, icon: "el-icon-delete" },
      on: { click: _vm.onClickButton },
    },
    [_vm._v("Eliminar")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }